import React, { Component } from "react";
import swal from "sweetalert";
import { Redirect } from "react-router-dom";
import { API, ROUTER } from "../constants/env";
export default function withAuth(ComponentToProtect) {
  return class extends Component {
    constructor() {
      super();
      this.state = {
        loading: true,
        redirect: false,
      };
    }
    componentWillMount() {
      console.log("d5al");
      fetch(API.me, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            localStorage.clear();
            return this.setState({ loading: false, redirect: true });
          }
          console.log("response is => ", response);
          localStorage.setItem("user", JSON.stringify(response));
          return this.setState({ loading: false });
        })
        .catch((err) => {
          swal("Erreur", "Probléme de connection", "error");
          localStorage.clear();
          this.setState({ loading: false, redirect: true });
          window.location = ROUTER.LOGIN;
        });
    }
    render() {
      const { loading, redirect } = this.state;
      if (loading) {
        return null;
      }
      if (redirect) {
        return <Redirect to={ROUTER.LOGIN} />;
      }
      return <ComponentToProtect {...this.props} />;
    }
  };
}
